import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Routes from './routes/Routes';
import reportWebVitals from './reportWebVitals';
import { SiteContextProvider } from './context/SiteContext';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { RouterProvider } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
const fallback = 
	<div className="grid place-content-center place-items-center min-h-screen">
		<Spin indicator={<LoadingOutlined spin />} size="large" />
	</div>
root.render(
	<SiteContextProvider>
		<Suspense fallback={fallback}>
			<RouterProvider router={Routes} />
		</Suspense>
	</SiteContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
